import spearPhishingAgentReducer from './spearPhishingAgentReducer'

// Acts both as a reducer (when called with state/action) and as a factory
// (when called with no arguments) to satisfy async reducer injection.
export default function createOrRunSpearPhishingAgentReducer(state, action) {
  if (state === undefined && action === undefined) {
    return spearPhishingAgentReducer
  }

  return spearPhishingAgentReducer(state, action)
}
